// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","637":"component---src-templates-blog-template-js","883":"component---src-pages-404-js","934":"component---src-pages-updates-jsx"}[chunkId] + "-" + {"230":"d7a82aab06ba1b31003a","637":"be40c5ef176521be1bcf","883":"291eea8436a9e635a98f","934":"ff214c31e90b5a621f88"}[chunkId] + ".js";
};